module.exports = __webpack_public_path__ + "static/media/csuid.53fb371d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/csuid.png
// module id = 1699
// module chunks = 0